export const badgeTypes = {
    negativeLight: 'negativeLight',
    negativeStrong: 'negativeStrong',
    positiveLight: 'positiveLight',
    positiveStrong: 'positiveStrong',
};
export const badgeSizes = {
    extraSmall: 'extraSmall',
    large: 'large',
    medium: 'medium',
    small: 'small',
};
